// extracted by mini-css-extract-plugin
module.exports = {"container":"ResponsiveMenuContainer_container__gimB9"};